import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 2l2.21 20H18.8L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z"
}), 'LocalDrinkSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LocalDrinkSharp.js
// module id = 4569
// module chunks = 2